import React from "react";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import styles from "../SiteMap/Sitemap.module.css";
const SiteMap = () => {
  const history = useHistory();

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const handleLinkClick = (path) => {
    history.push(path);
    scrollToTop();
  };

  return (
    <div>
      <div className={styles.sitemap}>
        <h2>SiteMap</h2>
        <ul className={styles.orderedList}>
          <li>
            <Link to="/" className={styles.links} onClick={handleLinkClick}>
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about-us"
              className={styles.links}
              onClick={handleLinkClick}
            >
              About Us
            </Link>
          </li>
          <li>
            <Link
              //   to="/about-us"
              className={styles.links}
              //   onClick={handleLinkClick}
            >
              Offerings
            </Link>
            <ul>
              <li>
                <Link
                  to="/portfolio-management-service"
                  className={styles.links}
                  onClick={handleLinkClick}
                >
                  - PMS
                </Link>
              </li>
              <li>
                <Link
                  to="/alternative-investment-funds"
                  className={styles.links}
                  onClick={handleLinkClick}
                >
                  - AIF
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link
              to="/investors-corner"
              className={styles.links}
              onClick={handleLinkClick}
            >
              Investor Corner
            </Link>
          </li>
          <li>
            <Link
              to="/market-insights"
              className={styles.links}
              onClick={handleLinkClick}
            >
              Insights
            </Link>
          </li>
          <li>
            <Link
              //   to="/about-us"
              className={styles.links}
              //   onClick={handleLinkClick}
            >
              Invest Now
            </Link>
            <ul>
              <li>
                <Link
                  to="/existing-investor"
                  className={styles.links}
                  onClick={handleLinkClick}
                >
                  - Existing Investor
                </Link>
              </li>
              <li>
                <Link
                  to="/invest-with-us"
                  className={styles.links}
                  onClick={handleLinkClick}
                >
                  - New Investor
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link
              to="/privacy-policy"
              className={styles.links}
              onClick={handleLinkClick}
            >
              Privacy Policy
            </Link>
          </li>
          <li>
            <Link
              to="/legal-terms"
              className={styles.links}
              onClick={handleLinkClick}
            >
              Legal Terms
            </Link>
          </li>
          <li>
            <Link
              to="/statutory-details"
              className={styles.links}
              onClick={handleLinkClick}
            >
              Statutory Details
            </Link>
          </li>

          <li>
            <Link to="/faqs" className={styles.links} onClick={handleLinkClick}>
              FAQs
            </Link>
          </li>
        </ul>

        {/* <ul className={styles.orderedList}>
          
        </ul> */}
      </div>
    </div>
  );
};

export default SiteMap;
